import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PmorderEditFormImpl from './PmorderEditFormImpl';
import PmorderList from './PmorderList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PmorderListView from './PmorderListView'


export default function PmorderDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.pmorderDashboard);
  const [ pmorderId, setPmorderId] = React.useState('');
  const [reloadPmorderList, setReloadPmorderList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PmorderEditFormImpl 
            setReloadPmorderList={setReloadPmorderList}
            pmorderId={pmorderId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PmorderListView 
                      setPmorderId = {setPmorderId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
